import { render, staticRenderFns } from "./ConfirmarAlteracaoSugestao.vue?vue&type=template&id=bb711058"
import script from "./ConfirmarAlteracaoSugestao.vue?vue&type=script&lang=js"
export * from "./ConfirmarAlteracaoSugestao.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarAlteracaoSugestao.vue?vue&type=style&index=0&id=bb711058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports